import { Component, OnInit } from '@angular/core';
import { WebsiteEnquiryService } from 'src/app/services/Enquiry/WebsiteEnquiry.Service';
/* Start Training Location Model Section */
interface EcbTrainingLocation {
  id: number;
  name: string;
  addressLineOne: string;
  addressLineTwo: string;
  phone: string;
  image: string;
  isHeadOffice: boolean;
}
/* End Training Location Model Section */


/* Start Location Feature Model Section */
interface EcbLocationFeature {
  id: number;
  title: string;
  icon: string;
}
/* End Location Feature Model Section */


/* Start About Feature Model Section */
interface EcbAboutFeature {
  id: number;
  title: string;
}
/* End About Feature Model Section */


/* Start Statistic Model Section */
interface EcbStatistic {
  id: number;
  value: string;
  label: string;
  icon: string;
}
/* End Statistic Model Section */

 


/* Start Corporate Feature Model Section */
interface EcbCorporateFeature {
  id: number;
  title: string;
}
/* End Corporate Feature Model Section */


/* Start Proposal Form Model Section */
interface EcbProposalForm {
  fullName: string;
  email: string;
  companyName: string;
  requirements: string;
}
/* End Proposal Form Model Section */

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {


  /* Start Property Declaration Section */
  public trainingLocations: EcbTrainingLocation[] = [];
  public locationFeatures: EcbLocationFeature[] = [];
  public aboutFeatures: EcbAboutFeature[] = [];
  public statistics: EcbStatistic[] = [];
 
  public corporateFeatures: EcbCorporateFeature[] = [];

  public proposalForm: EcbProposalForm = {
    fullName: '',
    email: '',
    companyName: '',
    requirements: ''
  };

  public isProposalSubmitting: boolean = false;
  public isProposalSuccess: boolean = false;
  /* End Property Declaration Section */


  /* Start Constructor Section */
  constructor(private websiteEnquiryService: WebsiteEnquiryService) {

  }
  /* End Constructor Section */


  /* Start Component Initialization Section */
  ngOnInit(): void {
    this.getTrainingLocations();
    this.getLocationFeatures();
    this.getAboutFeatures();
    this.getStatistics();
    
    this.getCorporateFeatures();
  }
  /* End Component Initialization Section */


  /* Start Training Location Static List Section */
  getTrainingLocations(): void {
    this.trainingLocations = [
      {
        id: 1,
        name: 'Victoria ',
        addressLineOne: '598 Kororoit Creek Rd,',
        addressLineTwo: 'Altona North, VIC 3025',
        phone: '1300 322 486​',
        image: 'assets/images/locations/contact_melbourne.png',
        isHeadOffice: true
      },
      {
        id: 2,
        name: 'Northern Territory',
        addressLineOne: '44 McMinn Street,',
        addressLineTwo: 'Darwin, NT 0800',
        phone: '08 7905 4026​',
        image: 'assets/images/locations/contact_brisbane.png',
        isHeadOffice: false
      } 
    ];
  }
  /* End Training Location Static List Section */


  /* Start Location Feature Static List Section */
  getLocationFeatures(): void {
    this.locationFeatures = [
      {
        id: 1,
        title: 'Australia Wide Locations',
        icon: 'bi bi-globe-asia-australia'
      },
      {
        id: 2,
        title: 'Modern Training Facilities',
        icon: 'bi bi-buildings'
      },
      {
        id: 3,
        title: 'Experienced Trainers',
        icon: 'bi bi-people'
      },
      {
        id: 4,
        title: 'Flexible Schedules',
        icon: 'bi bi-calendar3'
      },
      {
        id: 5,
        title: 'Industry Focused Programs',
        icon: 'bi bi-patch-check'
      },
      {
        id: 6,
        title: 'Onsite & Online Training',
        icon: 'bi bi-person-workspace'
      }
    ];
  }
  /* End Location Feature Static List Section */


  /* Start About Feature Static List Section */
  getAboutFeatures(): void {
    this.aboutFeatures = [
      {
        id: 1,
        title: 'Registered Training Organisation (RTO 41369)'
      },
      {
        id: 2,
        title: 'Nationally Accredited Courses'
      },
      {
        id: 3,
        title: 'Industry Experienced Trainers'
      },
      {
        id: 4,
        title: 'Trusted by Thousands of Students'
      },
      {
        id: 5,
        title: 'Focus on Safety, Quality & Compliance'
      }
    ];
  }
  /* End About Feature Static List Section */


  /* Start Statistic Static List Section */
  getStatistics(): void {
    this.statistics = [
      {
        id: 1,
        value: '25+',
        label: 'Years Experience',
        icon: 'bi bi-people'
      },
      {
        id: 2,
        value: '40+',
        label: 'National Courses',
        icon: 'bi bi-clipboard-check'
      },
      {
        id: 3,
        value: '15,000+',
        label: 'Students Trained',
        icon: 'bi bi-person-check'
      },
      {
        id: 4,
        value: '98%',
        label: 'Customer Satisfaction',
        icon: 'bi bi-patch-check'
      }
    ];
  }
  /* End Statistic Static List Section */

 

  /* Start Corporate Feature Static List Section */
  getCorporateFeatures(): void {
    this.corporateFeatures = [
      {
        id: 1,
        title: 'Customised Training Programs'
      },
      {
        id: 2,
        title: 'Onsite or Online Delivery'
      },
      {
        id: 3,
        title: 'Flexible Scheduling'
      },
      {
        id: 4,
        title: 'Group Discounts'
      },
      {
        id: 5,
        title: 'Tailored to Your Industry Needs'
      }
    ];
  }
  /* End Corporate Feature Static List Section */


  /* Start Proposal Submission Function Section */
 submitProposal(): void {

  if (
    !this.proposalForm.fullName.trim() ||
    !this.proposalForm.email.trim() ||
    !this.proposalForm.requirements.trim()
  ) {
    return;
  }


  if (this.isProposalSubmitting) {
    return;
  }


  this.isProposalSubmitting = true;
  this.isProposalSuccess = false;
  this.isProposalError = false;


  this.websiteEnquiryService
    .submitCorporateProposal(
      this.proposalForm
    )
    .subscribe({

      next: () => {

        this.isProposalSubmitting = false;
        this.isProposalSuccess = true;

        this.resetProposalForm();

        setTimeout(() => {
          this.isProposalSuccess = false;
        }, 5000);

      },

      error: (error) => {

        this.isProposalSubmitting = false;
        this.isProposalSuccess = false;
        this.isProposalError = true;

        console.error(
          'Corporate proposal submission failed:',
          error
        );

        setTimeout(() => {
          this.isProposalError = false;
        }, 5000);

      }

    });
}
  /* End Proposal Submission Function Section */
isProposalError = false;

  /* Start Proposal Form Reset Function Section */
  resetProposalForm(): void {
    this.proposalForm = {
      fullName: '',
      email: '',
      companyName: '',
      requirements: ''
    };
  }
  /* End Proposal Form Reset Function Section */


  /* Start Track By Function Section */
  trackById(index: number, item: { id: number }): number {
    return item.id;
  }
  /* End Track By Function Section */

}
